import { render, staticRenderFns } from "./AddAutoApproveCategoryModal.vue?vue&type=template&id=a812a95a&"
import script from "./AddAutoApproveCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddAutoApproveCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports